import React, { useState } from 'react';
import { ThemeProvider } from '@emotion/react';
import { BrowserRouter as Router } from 'react-router-dom';
import GlobalStyles from './styles';
import theme from './styles/themes/standard';
import history from './routing/history';
import { AuthProvider } from './hooks/useAuth';
import { CrossSellBarContainer } from './components/CrossSellBar';
import { NavbarContainer } from './components/Navbar';
import { ApplicationRoutes } from './routing/ApplicationRoutes';
import { AuthRefresh } from './components/Auth/Refresh';
import { SweepsProvider } from './hooks/useSweeps';
import { ErrorContext } from './hooks/useError';
import { FeaturesProvider } from './hooks/useFeatures';
import ScrollToTop from './routing/ScrollToTop';
import { CookieConsentProvider } from './hooks/useCookieConsents';
import { TermsAndConditionsProvider } from './hooks/useTermsAndConditions';
import { isPick7iOSWebView } from './utils/authUtils';

function App() {
    const [error, setError] = useState(null);

    return (
        <CookieConsentProvider>
            <AuthProvider>
                <AuthRefresh>
                    <FeaturesProvider>
                        <TermsAndConditionsProvider>
                            <SweepsProvider>
                                <ErrorContext.Provider
                                    value={{ error, setError }}
                                >
                                    <ThemeProvider theme={theme}>
                                        <GlobalStyles />
                                        <Router history={history}>
                                            <CrossSellBarContainer />
                                            {!isPick7iOSWebView() && (
                                                <NavbarContainer />
                                            )}
                                            <ScrollToTop>
                                                <ApplicationRoutes />
                                            </ScrollToTop>
                                        </Router>
                                    </ThemeProvider>
                                </ErrorContext.Provider>
                            </SweepsProvider>
                        </TermsAndConditionsProvider>
                    </FeaturesProvider>
                </AuthRefresh>
            </AuthProvider>
        </CookieConsentProvider>
    );
}

export default App;
